import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfDriver, ModelOfDriverForm, ModelOfMotoristaVeiculo, ModelOfVehicleItem } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfDriver = {
	ORGAO: '',
	NOME: '',
	DATANASCIMENTO: '',
	CPF: '',
	CNH: '',
	VALIDADECNH: '',
	CATEGORIACNH: '',
	SENHA: '',
	ORGAOUNIDADE: ''
};

const initialValuesOfUnityMotoristaVeiculo = {
	ID: '',
	FT_VEICULO: '',
	FT_MOTORISTA: '',
	DATAINICIO: '',
	DATAFIM: '',
};

export const useListDriversController = () => {
	const [driversData, setDriversData] = useState<ModelOfDriver[]>([]);
	const [allDriversData, setAllDriversData] = useState<ModelOfDriver[]>([]);
	const [selectedDriver, setSelectedDriver] = useState<ModelOfDriver>(initialValuesOfDriver);
	const [unityMotoristaVeiculoData, setUnityMotoristaVeiculoData] = useState<ModelOfMotoristaVeiculo[]>([])

	const [loading, setLoading] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [motoristaVeiculoDialog, setMotoristaVeiculoDialog] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);
	const [loadingRows, setLoadingRows] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();
	const [vehicleList, setVehicleList] = useState<ModelOfVehicleItem[]>([]);

	const [deleteMotoristaVeiculoDialog, setDeleteMotoristaVeiculoDialog] = useState(false);
	const [selectedUnityMotoristaVeiculo, setSelectedUnityMotoristaVeiculo] = useState<ModelOfMotoristaVeiculo>(initialValuesOfUnityMotoristaVeiculo);


	const vehicles = vehicleList.map(vehicle => {
		return { label: vehicle.PLACA + " | " + vehicle.DESCRICAO, value: vehicle.ID };
	});

	const getVehicleList = async (diver: ModelOfDriver) => {
		console.log("lista veiculos ...:", diver.ID)

		const response = await api.post(`get-vehicles`, { ORGAO: userAgencyId }).then((response) => {
			setVehicleList(response.data);
			setLoading(false);
		})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const validationSchema = Yup.object().shape({
		NOME: Yup.string().required('* Campo obrigatório'),
		DATANASCIMENTO: Yup.string().required('* Campo obrigatório'),
		CPF: Yup.string().required('* Campo obrigatório'),
		CNH: Yup.string().required('* Campo obrigatório'),
		VALIDADECNH: Yup.string().required('* Campo obrigatório'),
		CATEGORIACNH: Yup.string().required('* Campo obrigatório'),
		SENHA: Yup.string().required('* Campo obrigatório'),
	});

	const validationSchemaMotoristaVeiculo = Yup.object().shape({
		FT_VEICULO: Yup.string().required('* Campo obrigatório'),
		DATAINICIO: Yup.string().required('* Campo obrigatório'),
		DATAFIM: Yup.string().required('* Campo obrigatório'),
	});

	const getAllDrivers = async () => {
		setLoading(true);
		api.get(`drivers/${userAgencyId}`)
			.then(response => {
				const data = response.data;

				setAllDriversData(data);

				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};


	const getDrivers = async () => {
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		api.post('drivers2', { ROW: rows })
			.then(response => {
				console.log("Motorista: ", response)
				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					setDriversData(
						driversData.concat(
							response.data.filter((item: any) => {
								return item.ORGAO === userAgencyId;
							}),
						),
					);
					setLoading(false);
					setLoadingRows(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
				setLoadingRows(false);
			});
	};

	const removeDriver = (driver: ModelOfDriver) => {
		setLoading(true);
		api.delete(`drivers/${driver.ID}`)
			.then(response => {
				const newList = driversData.filter(driver => driver.ID !== response.data.ID);
				setDriversData(newList);
				getDrivers();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O motorista foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getDrivers();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editDriver = (driver: ModelOfDriverForm) => {
		setLoadingEdit(true);

		const editedDriver: ModelOfDriver = {
			...driver,
			ORGAO: userAgencyId,
			CATEGORIACNH: driver.CATEGORIACNH.join(','),
			DATANASCIMENTO: moment(driver.DATANASCIMENTO, 'DD/MM/YYYY').toDate().toLocaleDateString('en', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
			}),
			VALIDADECNH: moment(driver.VALIDADECNH, 'DD/MM/YYYY').toDate().toLocaleDateString('en', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
			}),
		};

		api.put(`drivers/${selectedDriver?.ID}`, editedDriver)
			.then(() => {
				// getDrivers();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O motorista foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				getDrivers();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getDrivers();
	}, [rows]);

	useEffect(() => {
		getAllDrivers();
	}, []);

	const openDeleteDialog = (driver: ModelOfDriver) => {
		setDeleteDialog(true);
		setSelectedDriver(driver);
	};

	const openMotoristaVeiculoDialog = (driver: ModelOfDriver) => {
		setMotoristaVeiculoDialog(true);
		setSelectedDriver(driver);
		getVehicleList(driver);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (driver: ModelOfDriver) => {
		setEditDialog(true);
		console.log("Senha -->:", driver.SENHA)
		setSelectedDriver(driver);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const closeMotoristaVeiculoDialog = () => {
		setMotoristaVeiculoDialog(false);
	};

	

	const formikMotoristaVeiculo = useFormik<ModelOfMotoristaVeiculo>({
		initialValues: {
			FT_MOTORISTA: '',
			DATAINICIO: '',
			DATAFIM: '',
			FT_VEICULO: '',
		},
		onSubmit: async values => await saveMotoristaVeiculo(values),
		validationSchema: validationSchemaMotoristaVeiculo,
	});

	const getMotoristaVeiculos = () => {
		setLoading(true)
		api.get(`motoristaveiculo/${selectedDriver?.ID}`)
			.then(response => {
				const data = response.data;
				setUnityMotoristaVeiculoData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.statusText);
				setLoading(false);
			});
		setLoading(false);
	};

	const saveMotoristaVeiculo = async (motoristaVeiculo: ModelOfMotoristaVeiculo) => {
		setLoading(true);
		if (selectedDriver.ID)
			motoristaVeiculo.FT_MOTORISTA = selectedDriver.ID
		console.log("motoristaVeiculo:", motoristaVeiculo)
		api.post('motoristaveiculo', motoristaVeiculo)
			.then((response) => {
				setLoading(false);
				toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
				getMotoristaVeiculos();
			}).catch((err) => {
				console.log("response: ", err)
				setLoading(false);
				toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
			});
		setLoading(false);
	}

	const editModtoristaVeiculo = async (motoristaVeiculo: ModelOfMotoristaVeiculo) => {

	}


	const formik = useFormik<ModelOfDriverForm>({
		initialValues: {
			ORGAO: '',
			NOME: '',
			DATANASCIMENTO: '',
			CPF: '',
			CNH: '',
			VALIDADECNH: '',
			CATEGORIACNH: '',
			LOGIN: '',
			SENHA: '',
			NIVEL: 1,
			ORGAOUNIDADE: '',
		},
		onSubmit: async values => await editDriver(values),
		validationSchema,
	});

	const openDeleteMotoristaVeiculoDialog = (motoristaVeiculo: ModelOfMotoristaVeiculo) => {
		setDeleteMotoristaVeiculoDialog(true);
		setSelectedUnityMotoristaVeiculo(motoristaVeiculo);
	};

	
	const closeDeleteMotoristaVeiculoDialog = () => {
		setDeleteMotoristaVeiculoDialog(false);
	};

	const removeMotoristaVeiculo = async (MotoristaVeiculo: ModelOfMotoristaVeiculo) => {
		setLoading(true);
        console.log("MotoristaVeiculo.ID --> ",MotoristaVeiculo.ID);
		api.delete(`motoristaveiculo/${MotoristaVeiculo.ID}`)
			.then(response => {
				const newList = unityMotoristaVeiculoData.filter(motoristaVeiculo => motoristaVeiculo.ID !== response.data.ID);
				setUnityMotoristaVeiculoData(newList);
				setDeleteMotoristaVeiculoDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O motorista veiculo foi removido com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getMotoristaVeiculos();
				setDeleteMotoristaVeiculoDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	return {
		getDriverListController: {
			formik,
			formikMotoristaVeiculo,
			driversData,
			allDriversData,
			selectedDriver,
			loading,
			deleteDialog,
			deleteMotoristaVeiculoDialog,
			motoristaVeiculoDialog,
			editDialog,
			loadingEdit,
			toast,
			rows,
			maxData,
			loadingRows,
			getMotoristaVeiculos,
			vehicles,
			unityMotoristaVeiculoData
		},
		handleDriverListController: {
			selectedUnityMotoristaVeiculo,
			removeDriver,
			editDriver,
			openDeleteDialog,
			openMotoristaVeiculoDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			closeMotoristaVeiculoDialog,
			setRows,
			editModtoristaVeiculo,
			deleteMotoristaVeiculoDialog,
			openDeleteMotoristaVeiculoDialog,
			closeDeleteMotoristaVeiculoDialog,
			removeMotoristaVeiculo
		},
	};
};
